/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_End_Round_HintInputs */



/**
* | output |
* | --- |
* | "All tables must be Finished first" |
*
* @param {Rounds_End_Round_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_end_round_hint = /** @type {((inputs?: Rounds_End_Round_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_End_Round_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les tables doivent être terminées d'abord")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todas las mesas deben estar finalizadas primero")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todas as mesas devem estar Finalizadas primeiro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prima tutti i tavoli devono essere Conclusi")
	return /** @type {LocalizedString} */ ("All tables must be Finished first")
});